import { ChartNavigatorPaneTitle, ChartNavigatorPaneTitleVue2 } from './Title';
export { ChartNavigatorPaneTitle, ChartNavigatorPaneTitleVue2 };
